const $inject = ['$scope', '$routeParams', 'settingsService', 'dataService','$timeout'];

const lbaSelectCtrl = function ($scope, $routeParams, settingsService, dataService,$timeout) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  if(vm.settings.handleAsString){
  vm.data = `${vm.data}`;
  }

  vm.getOptions = getOptions;
  vm.addSelected = addSelected;
  vm.items = getItemsToDisplay();

  // if no data (i.e. field is not filled out) load default
  if(!vm.data && vm.settings.defaultValue)
  {
      vm.data = vm.settings.defaultValue;
      _.set(dataService.data.activeItem, dataLookUp, vm.data)
  }

  // UI SELECT DOESN'T AUTO SELECT NUMBERS SO NEED TO CONVERT TO STRINGS...
  if (vm.settings.optionsNumbers) {
    vm.items.map(item => {
      item.value = `${item.value}`;

      return item;
    });

    vm.data = '' + vm.data;
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      if (vm.settings.allowNullable && newData === "") {
        newData = null;
      }

      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
    hideShowProperties(newData);
  });

  function getOptions(options, userInput) {
    const opts = angular.copy(options);
    if (userInput.length > 0) {
      opts.unshift(userInput);
    }
    return opts;
  }

  function addSelected(item) {
    if (vm.items.indexOf(item) === -1) {
      vm.items.unshift(item);
    }
  }

  function getItemsToDisplay() { 
    if (vm.settings.optionsAt) {
      let options = [...settingsService.options[vm.settings.optionsAt]];  
      
      if (vm.settings.allowNullable) { 
        options.unshift(null); 
      } 
      
      return options; 
    } 
    
    if (vm.settings.rangeValuesAt) { 
      let rangeValues = settingsService.options[vm.settings.rangeValuesAt]; 
      
      if (canGetRangeValues(rangeValues)) { 
        return arrayRange(rangeValues[0], rangeValues[1], 1) 
      } 
      
      console.log("There was an error displaying your range list") 
      
      return []; 
    } 
  }

  function arrayRange(start, stop, step){
    let resultRange = Array.from(
      { length: (stop - start) / step + 1 },
      (value, index) => {
        let result = vm.settings.showRangeValuesReverseOrder 
          ? stop - index * step 
          : start + index * step;
        return {
          label: `${result > 0 ? "+" : ""}${result}`,
          value: result
        }
      }
    );
    return resultRange;
  }

  function canGetRangeValues(rangeValues){
    return rangeValues.length && rangeValues.length === 2 && typeof rangeValues[0] === "number" && typeof rangeValues[1] === "number";
  }
  $timeout(() => hideShowProperties(vm.data),150);
  function hideShowProperties(val){
    if(!vm.settings.hideShowProperty) return;
    vm.items.forEach(opt=>{
        let classKey = "." + vm.settings.hideShowProperty;
        let className = classKey + "_"  + opt;
        if(val===opt){
          $(className).show();
        }else{
          $(className).hide();
        }
    });
  }
};

lbaSelectCtrl.$inject = $inject;

export default lbaSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaSelect/lbaSelectCtrl.js